import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { supabase } from "../../supabaseClient";

import Swal from "sweetalert2";
import ReactSelect from "react-select";

import Button from "../../Components/Button/index";
import SearchBar from "../../Components/SearchBar/index";
import Pagination from "../../Components/Pagination/index";
import { Modal } from "../../Components/Modal/index";

import { IoMdAdd, IoMdClose } from "react-icons/io";
import { FaEye } from "react-icons/fa";
import { MdDownload, MdModeEditOutline } from "react-icons/md";
import { IoDuplicateOutline } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import AllPagesTV from "../../Components/TVLandingPage/SchedulingTV";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { SchedulingSkeleton } from "../../Components/Skeleton";

export default function SchedulingList() {
  const navigate = useNavigate();

  // Core states
  const [schedules, setSchedules] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 100;

  // Filter states
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filters, setFilters] = useState([{ category: "", value: [] }]);

  // Option states
  const [brandOptions, setBrandOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [factoryOptions, setFactoryOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [languageOptions, setLanguageOptions] = useState([]);
  const [contentTypeOptions, setContentTypeOptions] = useState([]);
  const [genreOptions, setGenreOptions] = useState([]);

  // Label maps for chips
  const [allBrands, setAllBrands] = useState({});
  const [allVendors, setAllVendors] = useState({});
  const [allFactories, setAllFactories] = useState({});
  const [allLanguages, setAllLanguages] = useState({});
  const [allContentTypes, setAllContentTypes] = useState({});
  const [allGenres, setAllGenres] = useState({});
  const [showAllTv, setShowAllTv] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);
  const DATE_FMT = "MMM dd hh:mm aa";
  const minioBaseUrl = "https://images.do.cloudwalker.tv/images/";
  const DEFAULT_ROW_BG =
    "https://images.do.cloudwalker.tv/images/row-assets/row_bg/1770697896228-PercyJacksonAndTheOlympians2_1920x900.webp";

  const parseImageArray = (val) => {
    if (!val) return [];

    if (typeof val === "string") {
      const trimmed = val.trim();

      if (trimmed === "[]" || trimmed === "'[]'") return [];

      if (trimmed.startsWith("'[")) {
        try {
          val = JSON.parse(trimmed.slice(1, -1));
        } catch {
          return [];
        }
      } else if (trimmed.startsWith("[")) {
        try {
          val = JSON.parse(trimmed);
        } catch {
          return [];
        }
      } else {
        val = [val];
      }
    }

    if (!Array.isArray(val)) val = [val];

    return val
      .filter(Boolean)
      .map((v) =>
        v.startsWith("http") ? v : minioBaseUrl + v.replace(/^\/+/, ""),
      );
  };

  
  const normalizeScheduleJson = (schedule) => {
    const layoutNormalizationMap = {
      poster: "Landscape",
      landscape: "Landscape",
      banner: "Banner",
      "long banner": "LongBanner",
      featurebanner: "FeatureBanner",
      herobanner: "HeroBanner",
      portrait: "Portrait",
      square: "Square",
      "long portrait": "LongPortrait",
      logo: "TitleLogo",
      titlelogo: "TitleLogo",
      background: "Background",
    };

    const layoutImageFieldMap = {
      landscape: "poster",
      poster: "poster",
      banner: "banner",
      "long banner": "banner",
      featurebanner: "featureBanner",
      herobanner: "heroBanner",
      portrait: "portrait",
      square: "square",
      "long portrait": "longPortrait",
      logo: "titleLogo",
      titlelogo: "titleLogo",
      background: "background",
    };

    console.log("schedule.pages =>> ",schedule.pages)

    schedule.pages?.forEach((page) => {
      page.rows = page.rows?.map((row, rowIndex) => {
        const layout = (row.row_layout || "").toLowerCase().trim();

        const normalizedLayout = layoutNormalizationMap[layout] || row.row_layout;
        const primaryImageField = layoutImageFieldMap[layout] || "poster";

        // ✅ ROW BG normalize
        let rowBg = row.row_bg;
        if (!rowBg || rowBg.trim() === "") {
          rowBg = DEFAULT_ROW_BG;
        } else if (!rowBg.startsWith("http")) {
          rowBg =
            "https://images.do.cloudwalker.tv/images/" +
            rowBg.replace(/^\/+/, "");
        }

        const rowItems = row.row_items?.map((tile) => {
          const t = { ...tile };

          const pickAndResolve = (val) => {
            if (!val) return "";

            if (typeof val === "string" && val.startsWith("[")) {
              try {
                val = JSON.parse(val);
              } catch {}
            }

            if (Array.isArray(val)) val = val[0] || "";

            if (typeof val === "string" && !val.startsWith("http")) {
              return minioBaseUrl + val.replace(/^\/+/, "");
            }

            return val || "";
          };

          t.poster = pickAndResolve(t.poster);
          t.portrait = pickAndResolve(t.portrait);
          t.background = pickAndResolve(t.background);
          t.banner = pickAndResolve(t.banner);
          t.featureBanner = pickAndResolve(t.featureBanner);
          t.heroBanner = pickAndResolve(t.heroBanner);
          t.titleLogo = pickAndResolve(t.titleLogo);
          t.square = pickAndResolve(t.square);
          t.longPortrait = pickAndResolve(t.longPortrait);

          // REMOVE unwanted fields
          delete t.id;
          delete t.order;
          delete t.created_at;
          delete t.updated_at;
          delete t.updated_by;
          delete t.imdb_id;
          delete t.tags;
          delete t.languages;
          delete t.status;
          delete t.contentType;
          delete t.country;
          delete t.writer;
          delete t.image;

          // source → string
          if (Array.isArray(t.source)) {
            t.source = t.source[0] || "";
          } else if (!t.source) {
            t.source = "";
          }

          const clean = (v) =>
            v !== undefined && v !== null && String(v).trim() !== "";

          const finalTileType = clean(tile.tileType)
            ? tile.tileType
            : clean(t.tileType)
              ? t.tileType
              : "type1";

          const finalType = clean(tile.type)
            ? tile.type
            : clean(t.type)
              ? t.type
              : "START";

              console.log("t.genre =>> ",t.genre)

          const layoutSpecificImage =
            primaryImageField !== "poster" &&
            primaryImageField !== "portrait" &&
            primaryImageField !== "background" &&
            t[primaryImageField]
              ? { [primaryImageField]: t[primaryImageField] }
              : {};

          const orderedTile = {
            tileType: finalTileType,
            tid: t.tid,
            title: t.title,
            poster: t.poster,
            portrait: t.portrait,
            background: t.background,
            ...layoutSpecificImage,
            rating: Number(t.rating) || 0,
            runtime: t.runtime,
            startTime: Number(t.startTime) || 0,
            startIndex: Number(t.startIndex) || 0,
            target: Array.isArray(t.target)
              ? t.target
              : t.target
                ? [t.target]
                : [],
            type: finalType,
            useAlternate:
              t.useAlternate === true ||
              String(t.useAlternate).toLowerCase() === "true",
            alternateUrl: t.alternateUrl,
            playstoreUrl: t.playstoreUrl,
            package: t.package,
            detailPage: t.detailPage,
            source: t.source,
            genre: Array.isArray(t.genre) ? t.genre.slice(0, 5) : [],
            year: t.year != null ? String(t.year) : "",
            director: Array.isArray(t.director) ? t.director.slice(0, 5) : [],
            cast: Array.isArray(t.cast) ? t.cast.slice(0, 5) : [],
            synopsis: t.synopsis,
            showTileInfo:
              t.showTileInfo === true ||
              String(t.showTileInfo).toLowerCase() === "true",
          };

          const tileHasSize =
            t?.tileWidth &&
            String(t.tileWidth).trim() !== "" &&
            t?.tileHeight &&
            String(t.tileHeight).trim() !== "";

          const rowWidth = row?.row_width ?? row?.rowWidth;
          const rowHeight = row?.row_height ?? row?.rowHeight;

          const rowHasSize =
            rowWidth &&
            String(rowWidth).trim() !== "" &&
            rowHeight &&
            String(rowHeight).trim() !== "";

          if (tileHasSize) {
            orderedTile.tileWidth = String(t.tileWidth);
            orderedTile.tileHeight = String(t.tileHeight);
          } else if (rowHasSize) {
            orderedTile.tileWidth = String(rowWidth);
            orderedTile.tileHeight = String(rowHeight);
          } else {
            delete orderedTile.tileWidth;
            delete orderedTile.tileHeight;
          }

          return orderedTile;
        });

        // 🔥 RETURN CLEAN ROW STRUCTURE
        return {
          rowIndex,
          rowLayout: normalizedLayout,
          rowHeader: row.row_header,
          row_bg: rowBg,
          rowItems,
        };
      });
    });

    return schedule;
  };

  const showUpdateInfo = (schedule) => {
    Swal.fire({
      title: "Last Modified",
      html: `
      <div style="text-align:left; font-size:14px">
        <p><b>Updated By:</b> ${schedule.updated_by || "unknown"}</p>
        <p><b>Updated At:</b> ${
          schedule.updated_at
            ? new Date(schedule.updated_at).toLocaleString("en-IN", {
                timeZone: "Asia/Kolkata",
                dateStyle: "medium",
                timeStyle: "short",
              })
            : "N/A"
        }</p>
      </div>
    `,
      icon: "info",
      confirmButtonText: "Close",
    });
  };

  // Category config
  const categoryOptions = [
    { key: "brand", label: "Brand" },
    { key: "vendor", label: "Vendor" },
    { key: "factory", label: "Factory" },
    { key: "country", label: "Country" },
    { key: "languages", label: "Languages" },
    { key: "content_type", label: "Content Type" },
    { key: "genres", label: "Genres" },
  ];

  const isLive = (item) => {
    const now = new Date();
    const start = new Date(item.start_time);
    const end = new Date(item.end_time);
    return start <= now && now < end;
  };

  const getCategoryLabel = (cat) =>
    categoryOptions.find((c) => c.key === cat)?.label || cat;

  const getDisplayValue = (category, val) => {
    switch (category) {
      case "brand":
        return allBrands[val] || val;
      case "vendor":
        return allVendors[val] || val;
      case "factory":
        return allFactories[val] || val;
      case "country":
        return val;
      case "languages":
        return allLanguages[val] || val;
      case "content_type":
        return allContentTypes[val] || val;
      case "genres":
        return allGenres[val] || val;
      default:
        return val;
    }
  };

  const getOptionsForCategory = (category) => {
    switch (category) {
      case "brand":
        return brandOptions;
      case "vendor":
        return vendorOptions;
      case "factory":
        return factoryOptions;
      case "country":
        return countryOptions;
      case "languages":
        return languageOptions;
      case "content_type":
        return contentTypeOptions;
      case "genres":
        return genreOptions;
      default:
        return [];
    }
  };

  // Filter logic
  const filteredSchedules = schedules.filter((item) => {
    // Search filter
    if (
      searchQuery &&
      !item.name?.toLowerCase().includes(searchQuery.toLowerCase())
    ) {
      return false;
    }

    // Category filters (AND across categories, OR within category values)
    for (const f of filters) {
      if (f.value.length === 0) continue;

      let matches = false;
      switch (f.category) {
       
        case "brand":
          matches = (item.brand || []).some((id) => f.value.includes(id));
          break;
        case "vendor":
          matches = (item.vendor || []).some((id) => f.value.includes(id));
          break;
        case "factory":
          matches = (item.factory || []).some((id) => f.value.includes(id));
          break;

        case "country":
          matches = f.value.includes(item.country);
          break;
        case "languages":
          matches = (item.languages || []).some((lang) =>
            f.value.includes(lang),
          );
          break;
        case "content_type":
          matches = (item.content_type || []).some((ct) =>
            f.value.includes(ct),
          );
          break;
        case "genres":
          matches = (item.genres || []).some((genre) =>
            f.value.includes(genre),
          );
          break;
        default:
          matches = true;
      }
      if (!matches) return false;
    }
    return true;
  });

  const totalPages = Math.ceil(filteredSchedules.length / pageSize);
  const currentData = filteredSchedules.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize,
  );

  const hasActiveFilters = filters.some((f) => f.value.length > 0);

const handleDownloadScheduleJSON = async (scheduleId) => {
  try {
    const res = await fetch(
      "https://zigaeuvtypxeiwdraxca.supabase.co/functions/v1/get-schedule-data",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
        },
        body: JSON.stringify({ id: scheduleId }),
      }
    );

    console.log("res data =>> ",res)

    if (!res.ok) throw new Error("Failed to fetch schedule");

    let scheduleJson = await res.json();
    
    console.log("schedule json =>> ",scheduleJson)

    // =========================
    // ROW SIZE LOGIC (unchanged)
    // =========================
    const pageIds = scheduleJson.pages?.map((p) => p.page_id) || [];

    const { data: pagesData } = await supabase
      .from("pages")
      .select("*")
      .in("id", pageIds);

    const allRowIds = pagesData?.flatMap((p) => p.rows) || [];

    const { data: rowData } = await supabase
      .from("row_data")
      .select("id, row_width, row_height")
      .in("id", allRowIds);

    const rowSizeMap = Object.fromEntries(
      (rowData || []).map((r) => [
        r.id,
        { width: r.row_width, height: r.row_height },
      ])
    );

    scheduleJson.pages?.forEach((page) => {
      const realPage = pagesData?.find((p) => p.id === page.page_id);
      if (!realPage) return;

      page.rows?.forEach((row, index) => {
        const realRowId = realPage.rows[index];
        const realRowSize = rowSizeMap[realRowId];

        if (realRowSize) {
          row.row_width = realRowSize.width;
          row.row_height = realRowSize.height;
        }
      });
    });

    // =========================
    // NORMALIZE FIRST 🔥
    // =========================
    console.log("RAW BEFORE NORMALIZE", scheduleJson.pages);
    const normalized = normalizeScheduleJson(scheduleJson);
    console.log("AFTER NORMALIZE", normalized);

    // =========================
    // COLLECT UUIDs (AFTER normalize)
    // =========================
    const genreIds = new Set();
    const castIds = new Set();
    const directorIds = new Set();
    const sourceIds = new Set();
    console.log("Genreids just after initialized as empty set => ",genreIds);

    normalized.pages?.forEach((page) => {
      page.rows?.forEach((row) => {
        const items = row.rowItems || [];
        items.forEach((tile) => {
          tile.genre?.forEach((id) => genreIds.add(id));
          tile.cast?.forEach((id) => castIds.add(id));
          tile.director?.forEach((id) => directorIds.add(id));
          if (tile.source) sourceIds.add(tile.source);
        });
        console.log("Items after mapping foreach =>",items);
      });
    });

    // Legacy tiles store the readable name directly instead of a uuid.
    // Passing those through `.in("id", ...)` on a uuid column makes the
    // whole batched query fail, so only real uuids are looked up.
    const UUID_RE =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    const onlyUuids = (ids) => [...ids].filter((id) => UUID_RE.test(id));

    // =========================
    // FETCH FROM DB
    // =========================
    const [
      { data: genresData },
      { data: castData },
      { data: directorsData },
      { data: sourceData },
    ] = await Promise.all([
      supabase
        .from("genres")
        .select("id, genres")
        .in("id", onlyUuids(genreIds)),

      supabase
        .from("castMembers")
        .select('id, "castMembers"')
        .in("id", onlyUuids(castIds)),

      supabase
        .from("directors")
        .select("id, directors")
        .in("id", onlyUuids(directorIds)),

      supabase
        .from("source")
        .select("id, source")
        .in("id", onlyUuids(sourceIds)),
    ]);

    // =========================
    // CREATE MAPS
    // =========================
    const genreMap = Object.fromEntries(
      (genresData || []).map((g) => [g.id, g.genres])
    );

    const castMap = Object.fromEntries(
      (castData || []).map((c) => [c.id, c.castMembers])
    );

    const directorMap = Object.fromEntries(
      (directorsData || []).map((d) => [d.id, d.directors])
    );

    const sourceMap = Object.fromEntries(
      (sourceData || []).map((s) => [s.id, s.source])
    );

    // =========================
    // APPLY MAPPING 🔥
    // =========================
    normalized.pages?.forEach((page) => {
      page.rows?.forEach((row) => {
        const items = row.rowItems || [];

        items.forEach((tile) => {
         tile.genre = (Array.isArray(tile.genre)
  ? tile.genre
  : typeof tile.genre === "string"
  ? JSON.parse(tile.genre || "[]")
  : []
         ).map((id) => genreMap[id] || id);

          tile.cast = (tile.cast || []).map(
            (id) => castMap[id] || id
          );

          tile.director = (tile.director || []).map(
            (id) => directorMap[id] || id
          );

          tile.source = tile.source ? sourceMap[tile.source] || tile.source : "";
        });
      });
    });

    // =========================
    // FINAL FORMAT
    // =========================
    const startValue = normalized.start_time;
    const endValue = normalized.end_time;

    delete normalized.start_time;
    delete normalized.end_time;

    const fixedJson = {
      schedule_id: normalized.schedule_id,
      name: normalized.name,
      startTime: startValue,
      endTime: endValue,
      pages: normalized.pages,
      ...Object.fromEntries(
        Object.entries(normalized).filter(
          ([key]) => !["schedule_id", "name", "pages"].includes(key)
        )
      ),
    };

    // =========================
    // DOWNLOAD
    // =========================
    const blob = new Blob([JSON.stringify(fixedJson, null, 2)], {
      type: "application/json",
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "schedule.json";
    a.click();
    URL.revokeObjectURL(url);

  } catch (err) {
    console.error("Download error:", err);
  }
};

  const handleFilterChange = (index, key, value) => {
    const updatedFilters = [...filters];
    updatedFilters[index][key] = value;
    if (key === "category") {
      updatedFilters[index].value = [];
    }
    setFilters(updatedFilters);
  };

  const addFilter = () => {
    setFilters((prev) => [...prev, { category: "", value: [] }]);
  };

  const removeFilter = (index) => {
    const updatedFilters = filters.filter((_, i) => i !== index);
    setFilters(
      updatedFilters.length > 0
        ? updatedFilters
        : [{ category: "", value: [] }],
    );
  };

  const handleRemoveFilter = (category, val) => {
    setFilters((prevFilters) =>
      prevFilters.map((f) =>
        f.category === category
          ? { ...f, value: f.value.filter((v) => v !== val) }
          : f,
      ),
    );
  };

  const handleClearAll = () => {
    setFilters([{ category: "", value: [] }]);
    setCurrentPage(1);
  };

  const applyFilters = () => {
    setShowFilterModal(false);
    setCurrentPage(1);
  };

  // Data fetching
  const fetchSchedules = async () => {
    setLoading(true);
    const { data, error } = await supabase
      .from("scheduling")
      .select("*")
      .order("created_at", { ascending: false });
    if (error) {
      console.error("Error fetching schedules:", error);
    } else {
      setSchedules(data || []);
    }
    setLoading(false);
  };

  const loadOptions = async () => {
    try {
      const promises = [
        supabase.from("Brand").select("id, name"),
        supabase.from("Vendor").select("id, name"),
        supabase.from("Factory").select("id, name"),
        supabase.from("languages").select("id, languages"),
        supabase.from("contentType").select("id, contentType"),
        supabase.from("genres").select("id, genres"),
        supabase
          .from("scheduling")
          .select("country")
          .not("country", "is", null),
      ];

      const results = await Promise.all(promises);
      const [
        brandsRes,
        vendorsRes,
        factoriesRes,
        langsRes,
        ctRes,
        genresRes,
        countriesRes,
      ] = results;

      // Brands
      const sortedBrands = (brandsRes.data || []).sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setBrandOptions(
        sortedBrands.map((b) => ({ value: b.id, label: b.name })),
      );
      setAllBrands(Object.fromEntries(sortedBrands.map((b) => [b.id, b.name])));

      // Vendors
      const sortedVendors = (vendorsRes.data || []).sort((a, b) =>
        a.name.localeCompare(b.name),
      );
      setVendorOptions(
        sortedVendors.map((v) => ({ value: v.id, label: v.name })),
      );
      setAllVendors(
        Object.fromEntries(sortedVendors.map((v) => [v.id, v.name])),
      );

      // Factories
      const sortedFactories = (factoriesRes.data || []).sort((a, b) =>
        (a.name || "").localeCompare(b.name || ""),
      );
      setFactoryOptions(
        sortedFactories.map((f) => ({ value: f.id, label: f.name || "" })),
      );
      setAllFactories(
        Object.fromEntries(sortedFactories.map((f) => [f.id, f.name || ""])),
      );

      // Languages
      const sortedLangs = (langsRes.data || []).sort((a, b) =>
        a.languages.localeCompare(b.languages),
      );
      setLanguageOptions(
        sortedLangs.map((l) => ({ value: l.id, label: l.languages })),
      );
      setAllLanguages(
        Object.fromEntries(sortedLangs.map((l) => [l.id, l.languages])),
      );

      // Content Types
      const sortedCT = (ctRes.data || []).sort((a, b) =>
        a.contentType.localeCompare(b.contentType),
      );
      setContentTypeOptions(
        sortedCT.map((c) => ({ value: c.id, label: c.contentType })),
      );
      setAllContentTypes(
        Object.fromEntries(sortedCT.map((c) => [c.id, c.contentType])),
      );

      // Genres
      const sortedGenres = (genresRes.data || []).sort((a, b) =>
        a.genres.localeCompare(b.genres),
      );
      setGenreOptions(
        sortedGenres.map((g) => ({ value: g.id, label: g.genres })),
      );
      setAllGenres(
        Object.fromEntries(sortedGenres.map((g) => [g.id, g.genres])),
      );

      // Countries
      const uniqueCountries = Array.from(
        new Set(
          (countriesRes.data || []).map((d) => d.country).filter(Boolean),
        ),
      ).sort((a, b) => a.localeCompare(b));
      setCountryOptions(uniqueCountries.map((c) => ({ value: c, label: c })));
    } catch (error) {
      console.error("Error loading filter options:", error);
    }
  };

  // Search handler
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Delete handler
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete this schedule?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (result.isConfirmed) {
      const { error } = await supabase.from("scheduling").delete().eq("id", id);
      if (!error) {
        fetchSchedules();
      }
    }
  };

  // Duplicate handler
  const handleDuplicate = async (item) => {
    const { error } = await supabase.from("scheduling").insert({
      name: `${item.name} (copy)`,
      start_time: item.start_time,
      end_time: item.end_time,
      brand: item.brand,
      vendor: item.vendor,
      factory: item.factory,
      features: item.features,
      genres: item.genres,
      languages: item.languages,
      content_type: item.content_type,
      pages: item.pages,
      country: item.country,
      state: item.state,
      city: item.city,
      pincode: item.pincode,
    });
    if (!error) {
      fetchSchedules();
      Swal.fire("Duplicated!", "Schedule has been duplicated.", "success");
    }
  };

  // Reset page on search/filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filters]);

  // Initial load
  useEffect(() => {
    const init = async () => {
      await loadOptions();
      await fetchSchedules();
    };
    init();
  }, []);

  const formatDateTime = (value) => {
    if (!value) return "-";

    const date = new Date(value);

    // Extract readable parts
    const month = date.toLocaleString("en-US", { month: "short" }); // e.g. Nov
    const day = date.getDate().toString().padStart(2, "0");
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");

    // Convert to 12-hour clock
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    // Final format → MMM dd hh:mm aa
    return `${month} ${day} ${hours.toString().padStart(2, "0")}:${minutes} ${ampm}`;
  };

  return (
    <div className="p-6 max-h-[100%] overflow-y-auto bg-white">
      {/* Header */}
      <div className="flex flex-wrap items-center justify-center gap-4 mb-4">
        {/* Filter Button Group */}
        <div className="flex items-center gap-2">
          <Button
            variant="primary"
            className="px-4 py-2 text-sm flex items-center gap-2"
            onClick={() => setShowFilterModal(true)}
          >
            <IoMdAdd />
            Filter
          </Button>
          {hasActiveFilters && (
            <button
              onClick={handleClearAll}
              title="Clear Filters"
              className="p-2 text-gray-500 hover:text-red-500 transition-colors rounded-full bg-gray-100 hover:bg-red-50"
            >
              <IoMdClose size={18} />
            </button>
          )}
        </div>
        {/* Search */}
        <div className="w-full sm:w-1/2 lg:w-1/3">
          <SearchBar
            placeholder="Search Schedules"
            value={searchQuery}
            onChange={handleSearchChange}
            inputClassName="py-3"
          />
        </div>
        {/* Add Button */}
        <Button
          onClick={() => navigate("/scheduling/create")}
          variant="primary"
          className="px-6 py-2 text-sm flex items-center gap-2"
        >
          <IoMdAdd />
          Add Schedule
        </Button>
      </div>

      {hasActiveFilters && (
        <div className="flex flex-wrap items-center gap-2 mb-4 p-3 bg-gray-50 rounded-lg border">
          <span className="font-semibold text-gray-700">Filters:</span>

          {filters.flatMap((f, fIdx) =>
            f.value.map((val, vIdx) => (
              <div
                key={`${f.category}-${val}-${fIdx}-${vIdx}`}
                className="flex items-center gap-1 bg-gray-200 px-3 py-1 rounded-full text-sm text-gray-700 border border-gray-300"
              >
                <span>
                  {getCategoryLabel(f.category)}:{" "}
                  {getDisplayValue(f.category, val)}
                </span>

                <button
                  onClick={() => handleRemoveFilter(f.category, val)}
                  className="text-gray-600 hover:text-red-600 transition-colors"
                >
                  ✕
                </button>
              </div>
            )),
          )}

          <button
            onClick={handleClearAll}
            className="text-sm text-red-600 hover:underline ml-1 font-medium"
          >
            Clear All
          </button>
        </div>
      )}
      <div className="w-full mx-auto border p-4 h-[calc(100vh-9rem)] overflow-auto rounded-lg bg-white">
        <h1 className="text-3xl font-semibold uppercase border-b pb-3 mb-4 font-serif">
          Scheduling
        </h1>
        {loading ? (
          <SchedulingSkeleton count={10} />
        ) : currentData.length === 0 ? (
          <p className="text-center py-8 text-red-500 font-semibold">
            No records found
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm border-collapse">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                    Sr No
                  </th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                    Name
                  </th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                    Start Time
                  </th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                    End Time
                  </th>
                  <th className="border border-gray-300 px-4 py-3 text-left font-semibold">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData.map((item, index) => (
                  // <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                  <tr
                    key={item.id}
                    className={`transition-colors hover:bg-gray-50 ${
                      isLive(item) ? "bg-green-200" : ""
                    }`}
                  >
                    <td className="border px-4 py-3">{index + 1}</td>
                    {/* <td className="border px-4 py-3">{item.name}</td>
                     */}
                    <td className="py-2 px-3 border">
                      {item.name
                        ? item.name.charAt(0).toUpperCase() + item.name.slice(1)
                        : ""}
                    </td>
                    <td className="border px-4 py-3">
                      {formatDateTime(item.start_time)}
                    </td>
                    <td className="border px-4 py-3">
                      {formatDateTime(item.end_time)}
                    </td>
                    <td className="border px-4 py-3">
                      <div className="flex gap-2">
                       

                        <button
                          onClick={() => {
                            setPreviewItem(item.id); // store the schedule ID
                            setShowAllTv(true);
                          }}
                          className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-all"
                          title="Preview this schedule"
                        >
                          <FaEye size={14} />
                        </button>

                        <button
                          onClick={() => navigate(`/scheduling/${item.id}`)}
                          className="p-2 bg-yellow-100 text-yellow-600 rounded-lg hover:bg-yellow-200 transition-all duration-200 hover:scale-105 shadow-sm"
                          title="Edit"
                        >
                          <MdModeEditOutline size={16} />
                        </button>

                        <button
                          onClick={() => handleDelete(item.id)}
                          className="p-2 bg-red-100 text-red-600 rounded-lg hover:bg-red-200 transition-all duration-200 hover:scale-105 shadow-sm"
                          title="Delete"
                        >
                          <MdDelete size={16} />
                        </button>
                        <button
                          onClick={() => handleDuplicate(item)}
                          className="p-2 bg-indigo-100 text-indigo-600 rounded-lg hover:bg-indigo-200 transition-all duration-200 hover:scale-105 shadow-sm"
                          title="Duplicate"
                        >
                          <IoDuplicateOutline size={16} />
                        </button>

                        <button
                          onClick={() => handleDownloadScheduleJSON(item.id)}
                          className="p-2 bg-green-100 text-green-600 rounded-lg hover:bg-green-200 transition-all duration-200 hover:scale-105 shadow-sm"
                          title="Download JSON"
                        >
                          <MdDownload size={16} />
                        </button>

                        <button
                          onClick={() => showUpdateInfo(item)}
                          className="p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-all duration-200 hover:scale-105 shadow-sm"
                          title="Last modified info"
                        >
                          <AiOutlineInfoCircle size={16} />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>

              {/* All pages TV modal */}
              {showAllTv && previewItem && (
                <AllPagesTV
                  showModal={showAllTv}
                  setShowModal={setShowAllTv}
                  scheduleId={previewItem}
                />
              )}
            </table>
          </div>
        )}
      </div>
      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages || 1}
        onPageChange={handlePageChange}
      />
      {/* Filter Modal */}
      {showFilterModal && (
        <Modal
          customClasses="max-w-md w-full bg-white"
          showModal={showFilterModal}
          setShowModal={setShowFilterModal}
        >
          <div className="p-6 max-h-[80vh] overflow-y-auto">
            <h2 className="text-xl font-semibold mb-6">Filter Schedules</h2>
            <div className="space-y-6">
              {filters.map((filter, index) => (
                <div
                  key={index}
                  className="space-y-3 p-4 bg-gray-50 rounded-lg"
                >
                  {/* Category Selector */}
                  <ReactSelect
                    className="w-full"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    options={categoryOptions.map((opt) => ({
                      value: opt.key,
                      label: opt.label,
                    }))}
                    value={
                      filter.category
                        ? {
                            value: filter.category,
                            label:
                              categoryOptions.find(
                                (c) => c.key === filter.category,
                              )?.label || "",
                          }
                        : null
                    }
                    onChange={(selected) =>
                      handleFilterChange(
                        index,
                        "category",
                        selected?.value || "",
                      )
                    }
                    placeholder="Select Field"
                    isClearable={false}
                    isSearchable={false}
                  />
                  {/* Value Selector */}
                  {filter.category && (
                    <ReactSelect
                      isMulti
                      className="w-full"
                      classNamePrefix="react-select"
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      }}
                      options={getOptionsForCategory(filter.category)}
                      value={filter.value.map((val) => ({
                        value: val,
                        label: getDisplayValue(filter.category, val),
                      }))}
                      onChange={(selectedOptions) => {
                        const selectedValues = selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : [];
                        handleFilterChange(index, "value", selectedValues);
                      }}
                      placeholder={`Select ${getCategoryLabel(
                        filter.category,
                      )}`}
                      isSearchable
                    />
                  )}
                  {/* Remove Filter */}
                  <button
                    className="text-red-600 hover:text-red-700 text-sm font-medium underline"
                    onClick={() => removeFilter(index)}
                  >
                    Remove Filter
                  </button>
                </div>
              ))}
            </div>
            <Button
              variant="primary"
              onClick={addFilter}
              className=" mt-2 text-blue-600 hover:underline text-sm"
            >
              + Add Filter
            </Button>
            <div className="mt-8 flex justify-end gap-3 pt-6">
              <Button
                variant="secondary"
                onClick={() => setShowFilterModal(false)}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={applyFilters}>
                Apply Filters
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}
